module.exports = __webpack_public_path__ + "img/advantages.5b14fa59.png";